import {ActionList, ActionMenu, IconButton} from '@primer/react'
import type {PropsWithChildren} from 'react'
import {KebabHorizontalIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import styles from './Header.module.css'

export default function Header({children}: PropsWithChildren) {
  return <h3 className={styles.header}>{children}</h3>
}

interface AvatarProps extends PropsWithChildren {
  marginRight?: string | number
}
export function Avatar({marginRight, children}: AvatarProps) {
  return (
    <div className={styles.avatar} style={{marginRight: marginRight ?? '10px'}}>
      {children}
    </div>
  )
}

interface TitleProps {
  /**
   * When true, renders the title at --text-body-size-medium instead of the default --text-body-size-large.
   */
  small?: boolean
}

export function Title({children, small}: PropsWithChildren<TitleProps>) {
  /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
  return <div className={clsx('search-title', styles.title, small && styles.smallTitle)}>{children}</div>
}

/**
 * For best results, children should be ActionList.Item components.
 */
export function OverflowMenu({children}: PropsWithChildren) {
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        {/* eslint-disable-next-line primer-react/a11y-remove-disable-tooltip */}
        <IconButton unsafeDisableTooltip icon={KebabHorizontalIcon} aria-label="More" variant="invisible" />
      </ActionMenu.Anchor>

      <ActionMenu.Overlay>
        <ActionList>{children}</ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
